import React from 'react';
import styled from 'styled-components';
import { utils } from '@enso/components';
import theme from '../../../theme';

const HeroContainer = styled.section`
  padding: 90px 24px 0px;
  background-color: ${props => props.theme.color.backgroundWhite};

  @media ${utils.device.laptop} {
    padding: 75px 140px 0px;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;

  @media ${utils.device.laptop} {
    flex-direction: row;
    align-items: flex-start;
    gap: 100px;
    justify-content: flex-start;
  }
`;

const TextContainer = styled.div`
  flex: 0 1 auto;
  text-align: left;
  margin-top: 0;
  max-width: 600px;

  @media ${utils.device.laptop} {
    flex: 0 1 40%;
    max-width: 500px;
    margin-top: 0;
    padding-top: 0;
  }
`;

const Title = styled.h1`
  font-family: ${props => props.theme.font.title};
  font-size: 38px;
  font-weight: bold;
  color: #140d38;
  margin-bottom: 20px;
  margin-top: 0;
  line-height: 1.3;
  letter-spacing: -0.5px;

  @media ${utils.device.laptop} {
    font-size: 58px;
    margin-bottom: 28px;
    margin-top: 0;
    letter-spacing: -1px;
    line-height: 1.2;
  }
`;

const TitleLine = styled.span`
  display: block;
  font-weight: bold;

  &.orange {
    color: #fd5e43;
    white-space: nowrap;
  }

  &.dark {
    color: #140d38;
  }
`;

const ImageContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: 350px;
  width: 100%;
  overflow: visible;

  @media ${utils.device.laptop} {
    flex: 0 1 60%;
    min-height: 800px;
    width: auto;
    max-width: none;
    margin-left: 40px;
    justify-content: flex-end;
    align-items: flex-start;
  }
`;

const PhoneImage = styled.img`
  width: 100%;
  max-width: 100%;
  height: auto;
  display: block;
  object-fit: contain;

  @media ${utils.device.laptop} {
    width: auto;
    max-width: 650px;
    max-height: none;
    height: auto;
    object-fit: contain;
  }
`;

HeroContainer.defaultProps = { theme };
Title.defaultProps = { theme };

const Hero = function() {
  return (
    <HeroContainer>
      <ContentWrapper>
        <TextContainer>
          <Title>
            <TitleLine className="orange">Una nueva generación</TitleLine>
            <TitleLine className="dark">de servicios</TitleLine>
            <TitleLine className="dark">financieros</TitleLine>
          </Title>
        </TextContainer>
        <ImageContainer>
          <PhoneImage src="/images/home-phone.webp" alt="Enso app y tarjeta" />
        </ImageContainer>
      </ContentWrapper>
    </HeroContainer>
  );
};

export default Hero;
